Communication channels for a person.
